<template>
	<div class="store-list">
		<div v-for="store in markers" :key="store.infoText.address" class="store pt-3 pl-3 pr-3">
			<div class="store-info">
				<h4>{{store.infoText.name}}</h4>
				<ul class="mb-1">
					<li>{{store.infoText.address}}</li>
					<li>{{store.infoText.city}}, {{store.infoText.state}} {{store.infoText.zip}}</li>
					<li>{{store.infoText.phone}}</li>
					<li>{{store.infoText.open}} - {{store.infoText.close}}</li>
				</ul>
			</div>
			<div class="store-directions">
				<p v-if="store.distance">{{Math.ceil(store.distance * 0.000621371192)}} miles away</p>
				<a :href="`https://maps.google.com/maps?daddr=${store.infoText.address} ${store.infoText.city}, ${store.infoText.state} ${store.infoText.zip}`">Get Directions</a>
			</div>
			<hr class="mb-0">
		</div>
	</div>
</template>

<script>
export default {
	name: 'StoreList',
	props: {
		markers: Array
	}
}
</script>

<style scoped>
.store-list {
	border: 1px solid #eee;
	height: 500px;
	overflow-y: scroll;
}
.store-info h4{
	font-size: 15px;
}
.store-info ul{
	list-style: none;
	padding-left: 0px;
	font-size: 0.9em;
}
.store-directions {
	font-size: 0.8em;
}
</style>
